module.exports = __webpack_public_path__ + "img/male-icon.0decfcbb.svg";